// Lightweight analytics helper for GA4 + Microsoft Clarity
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // no-op
  }
  try {
    if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
      window.clarity('event', name);
    }
  } catch (e) {
    // no-op
  }
}

